export class PlanStageCompaundParametres {
    Id_Stage: number;
    Id_Plan: number;
    Id_recipe: number;
    DayId: number;
    ProfileId: number;
    EatingId: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/plan-stage-recipe-parametres.ts